export default __webpack_public_path__ + "static/media/707.887045ae.png";